import React from "react";
import { translations } from "../../utils/translations";

const getActiveLang = () => {
  const saved = localStorage.getItem("lang");
  if (saved && ["fr", "de", "en"].includes(saved)) return saved;
  return "fr";
};

export default function TwintTermsView() {
  const lang = getActiveLang();
  const t = translations[lang] || translations.fr;

  const items = Array.isArray(t?.twintTermsItems) ? t.twintTermsItems : [];

  return (
    <div className="main-content page-transition">
      <div className="legal-page-shell">
        <div className="legal-page-card">
          <header className="legal-page-header">
            <h1>{t.twintTermsTitle || "Conditions de paiement TWINT"}</h1>
            <p className="legal-page-updated">
              {t.twintTermsUpdated || "Dernière mise à jour : 31 octobre 2024"}
            </p>
          </header>

          <section className="legal-page-section">
            <p className="legal-page-intro">{t.twintTermsIntro || ""}</p>

            {items.length > 0 ? (
              <ol className="legal-page-list">
                {items.map((item, index) => (
                  <li key={`twint-term-${index}`}>{item}</li>
                ))}
              </ol>
            ) : null}
          </section>
        </div>
      </div>

      <style jsx="true">{`
        .legal-page-shell {
          max-width: 1100px;
          margin: 0 auto;
          padding: 48px 20px 80px;
        }

        .legal-page-card {
          background: rgba(255, 255, 255, 0.96);
          border: 1px solid rgba(212, 175, 55, 0.18);
          border-radius: 22px;
          box-shadow: 0 18px 50px rgba(0, 0, 0, 0.05);
          padding: 34px 28px;
        }

        .legal-page-header {
          margin-bottom: 28px;
          padding-bottom: 18px;
          border-bottom: 1px solid rgba(0, 0, 0, 0.08);
        }

        .legal-page-header h1 {
          margin: 0 0 10px;
          font-family: "Playfair Display", serif;
          font-size: clamp(1.8rem, 4vw, 2.6rem);
          line-height: 1.1;
          letter-spacing: 0.02em;
          color: #1f1a17;
        }

        .legal-page-updated {
          margin: 0;
          font-size: 0.95rem;
          color: rgba(0, 0, 0, 0.62);
        }

        .legal-page-section {
          display: grid;
          gap: 18px;
        }

        .legal-page-intro {
          margin: 0;
          font-size: 1rem;
          line-height: 1.8;
          color: #2a241f;
        }

        .legal-page-list {
          margin: 0;
          padding-left: 22px;
          display: grid;
          gap: 14px;
        }

        .legal-page-list li {
          line-height: 1.8;
          color: #2f2924;
        }

        @media (max-width: 780px) {
          .legal-page-shell {
            padding: 28px 14px 110px;
          }

          .legal-page-card {
            padding: 24px 18px;
            border-radius: 18px;
          }

          .legal-page-header {
            margin-bottom: 22px;
            padding-bottom: 14px;
          }

          .legal-page-updated {
            font-size: 0.9rem;
          }

          .legal-page-intro,
          .legal-page-list li {
            font-size: 0.96rem;
            line-height: 1.72;
          }
        }

        @media (max-width: 520px) {
          .legal-page-shell {
            padding: 22px 12px 120px;
          }

          .legal-page-card {
            padding: 20px 15px;
          }

          .legal-page-list {
            padding-left: 18px;
            gap: 12px;
          }
        }
      `}</style>
    </div>
  );
}
